import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { TextInput } from '@olxbr/ds-web'

const Content = styled(View)`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
`

const CodeWrapper = styled(View)`
  margin-right: var(--spacing-1);
  margin-left: var(--spacing-1);
`

const CustomInput = styled(TextInput)`
  .olx-text-input__input-field {
    padding-left: var(--spacing-1);
    padding-right: var(--spacing-1);
    text-align: center;
  }
`

const CODE_LENGTH = 6

function replaceAt(pincode, index, replace) {
  const copy = [...pincode]
  copy[index] = replace
  return copy
}

const isLastNumber = i => i === CODE_LENGTH - 1

const isValid = pincode => pincode.join('').replace(/ /g, '').length === CODE_LENGTH

const isOneDigit = i => /^\d$/.test(i)

class PinCode extends React.Component {
  constructor(props) {
    super(props)
    this.inputs = new Array(CODE_LENGTH)
    this.state = {
      pincode: new Array(CODE_LENGTH).fill(''),
    }
  }

  componentDidMount() {
    setTimeout(() => this.updateFocus(0), 0)
  }

  onKeyPress = ({ key }, i) => {
    const { pincode } = this.state
    const { onChange } = this.props

    if (key === 'Enter') {
      if (i + 1 === CODE_LENGTH) {
        const { onSubmitEditing } = this.props
        if (typeof onSubmitEditing === 'function') {
          onSubmitEditing()
        }
      }
      this.goToNextInput(i)
    } else if (key === 'Backspace') {
      if (pincode[i].trim() === '') {
        this.goToPreviusInput(i)
      } else {
        const newCode = replaceAt(pincode, i, '')
        this.setState({ pincode: newCode }, () => {
          if (typeof onChange === 'function') {
            onChange(newCode.join(''), isValid(newCode))
          }
        })
      }
    }
  }

  onCodeChange = (event, i) => {
    const { pincode } = this.state
    const { onChange } = this.props
    const { value } = event.target

    if (value && value.length) {
      const chars = value.split('')
      let index = i
      let newCode = pincode
      chars.forEach(c => {
        if (isOneDigit(c) && index < CODE_LENGTH) {
          newCode = replaceAt(newCode, index, c)
          this.goToNextInput(index)
          index += 1
        }
      })
      this.setState({ pincode: newCode }, () => {
        if (typeof onChange === 'function') {
          onChange(newCode.join(''), isValid(newCode))
        }
      })
      if (isLastNumber(i)) {
        this.onKeyPress({ key: 'Enter' }, i)
      }
    }
  }

  updateFocus = input => {
    if (this.inputs[input] && this.inputs[input].focus) {
      this.inputs[input].focus()
    }
    setTimeout(() => this.selectText(input), 0)
  }

  selectText = input => {
    if (this.inputs[input] && this.inputs[input].select) {
      this.inputs[input].select()
    }
  }

  goToNextInput(currentInput) {
    const nextInput = currentInput + 1
    if (nextInput < CODE_LENGTH) {
      this.updateFocus(nextInput)
    }
  }

  goToPreviusInput(currentInput) {
    const previousInput = currentInput - 1
    if (previousInput >= 0) {
      this.updateFocus(previousInput)
    }
  }

  render() {
    const { value: pincodeByProps, onFocus, modalMode } = this.props
    let { pincode } = this.state
    if (pincodeByProps && isValid(pincodeByProps.split(''))) {
      pincode = pincodeByProps.split('')
    }
    const { disabled, onSubmitEditing, hasError } = this.props
    return (
      <Content>
        {pincode.map((value, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <CodeWrapper key={i}>
            <CustomInput
              id={`input-pincode-${i}`}
              aria-label={`Codigo de verificação da ${i + 1}º posição de 6 posições`}
              aria-required
              onChange={event => this.onCodeChange(event, i)}
              onKeyDown={event => this.onKeyPress(event, i)}
              value={value || ''}
              keyboardType="number-pad"
              ref={x => {
                this.inputs[i] = x
              }}
              onFocus={() => {
                this.selectText(i)
                if (typeof onFocus === 'function') {
                  onFocus()
                }
              }}
              state={hasError && 'error'}
              disabled={disabled}
              type="tel"
            />
          </CodeWrapper>
        ))}
      </Content>
    )
  }
}

PinCode.propTypes = {
  disabled: PropTypes.bool,
  onSubmitEditing: PropTypes.func,
  pinCode: PropTypes.object,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  onFocus: PropTypes.func,
  modalMode: PropTypes.bool,
}

export default PinCode
